var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleUnavailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.21005L8.50502 6.70503L9.49497 7.69497L7.98995 9.2L9.49497 10.705L8.50502 11.695L7 10.1899L5.49497 11.695L4.50503 10.705L6.01005 9.2L4.50503 7.69497L5.49498 6.70502L7 8.21005Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4 0H2V2H1C0.944319 2 0.889701 2.00455 0.836497 2.0133C0.792349 2.00457 0.746709 2 0.7 2C0.313401 2 0 2.3134 0 2.7V13.3C0 13.6866 0.313401 14 0.7 14L0.705954 14H13.2941L13.3001 14C13.6867 14 14.0001 13.6866 14.0001 13.3V2.7C14.0001 2.3134 13.6867 2 13.3001 2C13.2534 2 13.2077 2.00458 13.1636 2.01331C13.1103 2.00455 13.0557 2 13 2H12.0001V0H10.6001V2H7.70005V0H6.30005V2H3.4V0ZM1.4 6H12.6001V12.6H1.4V6Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleUnavailable);
export default __webpack_public_path__ + "static/media/schedule_unavailable.cc9346c3.svg";
export { ForwardRef as ReactComponent };